import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Field } from "formik";

import FormikSemanticInput from "./FormikSemanticInput.jsx";

class FormikConfirmedEmailInput extends PureComponent {
  static propTypes = {
    required: PropTypes.bool.isRequired
  };

  static defaultProps = {
    required: true
  };

  // -- RENDER -- //

  render() {
    const { required, apiErrors } = this.props;

    return (
      <Fragment>
        <Field
          name="email"
          label="Email"
          placeholder="Email address"
          type="email"
          required={required}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
        <Field
          name="emailConfirmation"
          label="Confirm Email"
          placeholder="Email address"
          type="email"
          required={required}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
      </Fragment>
    );
  }
}

export default FormikConfirmedEmailInput;
